<div class="card">
    <div class="font-semibold text-xl mb-4">Ordenes Emitidas HOY</div>
    <p-table [value]="filteredOrders" [paginator]="true" dataKey="idOrder" [rows]="10" [rowHover]="true" [globalFilterFields]="['ciOrder', 'nameOrder']">
        <ng-template #header>
            <tr>
                <th pSortableColumn="ciOrder">Cédula <p-sortIcon field="ciOrder"></p-sortIcon></th>
                <th pSortableColumn="nameOrder">Nombre <p-sortIcon field="nameOrder"></p-sortIcon></th>
                <th>Preferencial</th>
                <th>Estado</th>
                <th>Acciones</th>
                <!-- <th>View</th> -->
            </tr>
        </ng-template>
        <ng-template #body let-order>
            <tr>
                <td>{{ order.ciOrder }}</td>
                <td>{{ order.nameOrder }}</td>
                <td>
                    <p-tag [value]="order.isSecure ? 'Sí' : 'No'" [severity]="order.isSecure ? 'success' : 'info'"></p-tag>
                </td>
                <td style="width: 15%">
                    <p-tag
                        [value]="
                            getOrderStatusCodeById(order.statusOrder) === 'PENDING'
                                ? 'Pendiente'
                                : getOrderStatusCodeById(order.statusOrder) === 'IN_PROGRESS'
                                  ? 'En proceso'
                                  : getOrderStatusCodeById(order.statusOrder) === 'INCOMPLETE'
                                    ? 'Incompleto'
                                    : getOrderStatusCodeById(order.statusOrder) === 'COMPLETED'
                                      ? 'Completado'
                                      : getOrderStatusCodeById(order.statusOrder) === 'CANCEL'
                                        ? 'Cancelado'
                                        : getOrderStatusCodeById(order.statusOrder)
                        "
                        [severity]="
                            getOrderStatusCodeById(order.statusOrder) === 'PENDING'
                                ? 'danger'
                                : getOrderStatusCodeById(order.statusOrder) === 'IN_PROGRESS'
                                  ? 'warn'
                                  : getOrderStatusCodeById(order.statusOrder) === 'INCOMPLETE'
                                    ? 'warn'
                                    : getOrderStatusCodeById(order.statusOrder) === 'COMPLETED'
                                      ? 'success'
                                      : getOrderStatusCodeById(order.statusOrder) === 'CANCEL'
                                        ? 'secondary'
                                        : 'info'
                        "
                    ></p-tag>
                </td>
                <td class="flex items-center">
                    <button pButton icon="pi pi-eye" text rounded severity="info" pTooltip="Ver archivos de la orden" (click)="openOrderDetail(order)"></button>
                    <!-- <button pButton icon="pi pi-image" (click)="openOrderFilesModal(order)" text rounded
                                severity="info" pTooltip="Ver archivos de la orden"></button>
                            <button pButton icon="pi pi-file-plus" (click)="openAttachOrderModal(order)" rounded
                                severity="warn" text pTooltip="Adjunta una imagen de orden"></button> -->
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

@if (pendingOrders.length > 0) {
    <div class="card mt-4">
        <div class="font-semibold text-xl mb-4 flex align-items-center gap-2">
            <i class="pi pi-exclamation-triangle text-red-500"></i>
            Ordenes con Resultados Pendientes
            <p-tag [value]="pendingOrders.length.toString()" severity="danger"></p-tag>
        </div>
        <p-table [value]="pendingOrders" dataKey="idOrder" [rows]="5" [rowHover]="true">
            <ng-template #header>
                <tr>
                    <th>N° Orden</th>
                    <th>Paciente</th>
                    <th>Estado</th>
                    <th>Pendientes</th>
                    <th>Acciones</th>
                </tr>
            </ng-template>
            <ng-template #body let-order>
                <tr>
                    <td>{{ order.codOrder }}</td>
                    <td>{{ order.nameOrder }}</td>
                    <td>
                        <p-tag
                            [value]="
                                getOrderStatusCodeById(order.statusOrder) === 'PENDING'
                                    ? 'Pendiente'
                                    : getOrderStatusCodeById(order.statusOrder) === 'IN_PROGRESS'
                                      ? 'En proceso'
                                      : getOrderStatusCodeById(order.statusOrder) === 'INCOMPLETE'
                                        ? 'Incompleto'
                                        : getOrderStatusCodeById(order.statusOrder) === 'COMPLETED'
                                          ? 'Completado'
                                          : getOrderStatusCodeById(order.statusOrder) === 'CANCEL'
                                            ? 'Cancelado'
                                            : getOrderStatusCodeById(order.statusOrder)
                            "
                            [severity]="
                                getOrderStatusCodeById(order.statusOrder) === 'PENDING'
                                    ? 'danger'
                                    : getOrderStatusCodeById(order.statusOrder) === 'IN_PROGRESS'
                                      ? 'warn'
                                      : getOrderStatusCodeById(order.statusOrder) === 'INCOMPLETE'
                                        ? 'warn'
                                        : getOrderStatusCodeById(order.statusOrder) === 'COMPLETED'
                                          ? 'success'
                                          : getOrderStatusCodeById(order.statusOrder) === 'CANCEL'
                                            ? 'secondary'
                                            : 'info'
                            "
                        >
                        </p-tag>
                    </td>
                    <td>
                        <p-tag [value]="(order.orderDetail || []).filter((d) => (d.fileCount ?? 0) === 0).length.toString()" severity="danger"> </p-tag>
                    </td>
                    <td>
                        <button pButton icon="pi pi-eye" text rounded severity="info" pTooltip="Ver detalle de la orden" (click)="openOrderDetail(order)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
}
